import React from 'react';
import LoadingSpinner from '@JohnLewisPartnership/jl-design-system/components/loading-spinner/LoadingSpinner';
import classnames from 'classnames';

import styles from './Loading.module.scss';

type Props = {
  showSpinner: boolean;
};

const Loading = ({ showSpinner }: Props) => (
  <div className={classnames(styles.loading)}>
    {showSpinner ? <LoadingSpinner /> : null}
  </div>
);

export default Loading;
